import { BReactComponent } from 'blocks-cloud/b-react-component';
import app from 'Cloud/Application/app';
import { whatIsShowingBanner } from 'Cloud/Application/NewPromoController';
import Promo from 'Cloud/Application/Promo';
import { promoController } from 'Cloud/Application/PromoController';
import browser from 'Cloud/browser';
import config from 'Cloud/config';
import { BannerRightAdaptive } from 'reactApp/ui/BannerRightAdaptive/BannerRightAdaptive';

var banner = config.get('REACT_TABLET_BANNER');

function init() {
    const show = !!banner && !config.get('IS_AUTO_TEST_HIDE') && !whatIsShowingBanner();
    const root = document.getElementById('react-banners');

    if (!root || !show) {
        return;
    }

    if (!(app.isHome() && banner.showOnHome) && !(app.isPublic() && banner.showOnPublic)) {
        return;
    }

    if (
        (banner.showOnPhone && browser.isPhone()) ||
        (banner.showOnTablet && browser.isTablet()) ||
        (banner.showOnDesktop && !browser.isMobile())
    ) {
        const ReactBanner = new BReactComponent({
            ReactComponent: BannerRightAdaptive,
            renderMode: 'append',
        });

        const handleShow = () => {
            if (banner.show_pixel) {
                new Image().src = banner.show_pixel;
            }
        };

        const handleClick = () => {
            if (banner.click_pixel) {
                new Image().src = banner.click_pixel;
            }
        };
        const handleClose = ({ sendPixel = true } = {}) => {
            if (banner.close_pixel && sendPixel) {
                new Image().src = banner.close_pixel;
            }
            ReactBanner.destroy(true, true);
        };

        if (banner.id === 'get-mobile-app-banner') {
            const BODY_MOBILE_PROMO = 'body_get-mobile-app-promo';

            const handleShowBanner = () => {
                handleShow();
                document.body.classList.add(BODY_MOBILE_PROMO);
            };

            const handleCloseBanner = ({ sendPixel = true } = {}) => {
                handleClose({ sendPixel: sendPixel });
                document.body.classList.remove(BODY_MOBILE_PROMO);
            };

            const mobileBannerPromo = Object.assign(new Promo(banner.id), {
                isEnabled: () => !(app.user && app.user.isNewbie()) && !!banner,
            });

            promoController.register(6000, mobileBannerPromo);

            if (promoController.canShow(banner.id)) {
                ReactBanner.renderTo(root, {
                    props: {
                        onClose: handleCloseBanner,
                        onClick: handleClick,
                        onShow: handleShowBanner,
                        title: banner.title,
                        description: banner.description,
                        imageUrl: banner.imageUrl,
                        imageAutoScale: banner.imageAutoScale,
                        backColor: banner.backColor,
                        textColor: banner.textColor,
                        isHorizontal: true,
                        withInput: true,
                        gaName: banner.id,
                        gaCategory: 'get-mobile-app-banner',
                        hideAfterDialog: true,
                    },
                });
            }
        }

        if (banner.id === 'tablet-banner') {
            ReactBanner.renderTo(root, {
                props: {
                    onClose: handleClose,
                    onClick: handleClick,
                    onShow: handleShow,
                    title: banner.title,
                    description: banner.description,
                    buttonText: banner.button,
                    buttonHorizontalText: banner.buttonHorizontal,
                    imageUrl: banner.imageUrl,
                    imageAutoScale: banner.imageAutoScale,
                    backColor: banner.backColor,
                    textColor: banner.textColor,
                    btnTextColor: banner.btnTextColor,
                    btnBackColor: banner.btnBackColor,
                    clickUrl: browser.isIOS() ? banner.clickUrlIos || banner.clickUrl : banner.clickUrlAndroid || banner.clickUrl,
                    withButton: true,
                    gaName: banner.id,
                    gaCategory: 'tablet-banner',
                },
            });
        }
    }

    window.dispatchEvent(new CustomEvent('resize'));
}

export default () => init();
